var e = function e(_e) {
  return void 0 !== _e.auto ? (n = _e.auto, r = n.daysEndInnerOuterFromToday || 4, a = n.daysInnerExtent || 30, o = new Date(), {
    start: (d = o.getTime() - 6e4 * o.getTimezoneOffset() - 864e5 * r) - 864e5 * a,
    end: d
  }) : {
    start: (t = _e).innerExtent[0],
    end: t.innerExtent[1]
  };
  var t, n, r, a, o, d;
};

export { e as getTimebarRangeByWorkspace };